import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { api } from "@/lib/clinic";
import { Logo } from "@/components/Logo";
import { Loader2 } from "lucide-react";

// Guardia globale: prima di mostrare qualsiasi pagina del gestionale chiede
// al server se la sessione è valida (il cookie non è leggibile dal frontend).
export const AuthGate = ({ children }) => {
  const [stato, setStato] = useState("verifica");

  useEffect(() => {
    let vivo = true;
    api
      .get("/auth/me")
      .then(({ data }) => vivo && setStato(data?.autenticato ? "ok" : "no"))
      .catch(() => vivo && setStato("no"));
    return () => {
      vivo = false;
    };
  }, []);

  if (stato === "verifica") {
    return (
      <div className="min-h-screen bg-[#0A0F1D] flex flex-col items-center justify-center gap-6" data-testid="auth-splash">
        <Logo invert className="h-10 opacity-90" />
        <div className="flex items-center gap-2 text-slate-400 text-sm uppercase tracking-[0.28em]">
          <Loader2 className="w-4 h-4 animate-spin" /> Verifica accesso
        </div>
      </div>
    );
  }
  if (stato === "no") return <Navigate to="/login" replace />;
  return children;
};
